import React, { FC } from 'react';
import { EntryPage } from '../../entrypages/EntryPage';
import { useParams } from 'react-router';

export const LoteEntryPage: FC = () => {
    const { loanFormat } = useParams<'loanFormat'>();

    return <EntryPage pageType="LOTE" loanFormat={loanFormat} />;
};
